import React from 'react'
import UpdateBillPay from 'src/app/UpdateBillPay/UpdateBillPay'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateBillPayRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateBillPayVirtualCardAppRoute: AppRoute = {
  id: AppLocation.UpdateBillPayVirtualCard,
  routeProps: updateBillPayRouteProps,
  component: <UpdateBillPay />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateBillPayVirtualCardAppRoute
